// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pidgeot: PokeData = {
  "id": 18,
  "name": "pidgeot",
  "height": 15,
  "weight": 395,
  "base_experience": 216,
  "types": [
    PokeType.NORMAL,
    PokeType.FLYING
  ],
  "api_moves": [
    "razor-wind",
    "gust",
    "wing-attack",
    "whirlwind",
    "sand-attack",
    "tackle",
    "agility",
    "quick-attack",
    "mirror-move",
    "sky-attack",
    "twister",
    "heat-wave",
    "feather-dance",
    "aerial-ace",
    "roost",
    "tailwind",
    "air-slash",
    "hurricane"
  ],
  "moves": [
    "gust",
    "tackle",
    "agility",
    "quick-attack",
    "sky-attack",
    "aerial-ace",
    "roost",
    "tailwind",
    "air-slash",
    "hurricane",
    "brave-bird",
    "headbutt",
    "chatter"
  ],
  "evolution_chain": {
    "id": 6,
    "item": null,
    "species": [
      {
        "name": "pidgey",
        "order": 16,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "pidgeotto",
        "order": 17,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 16,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "pidgeot",
        "order": 18,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 17,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 120,
    "speed": 156,
    "ability_power": 124
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
